const BLOCKED_TAGS = [
  'script',
  'style',
  'iframe',
  'object',
  'embed',
  'form',
  'input',
  'button',
  'textarea',
  'select',
  'meta',
  'link',
  'base',
];

const JAVASCRIPT_PROTOCOL = /^\s*javascript:/i;

export const sanitizeHtml = (rawHtml: string): string => {
  if (!rawHtml) {
    return '';
  }

  // Preserva saltos de linea cuando llegan como texto plano desde el servicio.
  const normalizedHtml = rawHtml.replace(/\r\n?/g, '\n').replace(/\n/g, '<br />');

  if (typeof window === 'undefined') {
    return normalizedHtml;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(`<div>${normalizedHtml}</div>`, 'text/html');
  const root = doc.body.firstElementChild as HTMLElement | null;

  if (!root) {
    return '';
  }

  root.querySelectorAll(BLOCKED_TAGS.join(',')).forEach((node) => node.remove());

  root.querySelectorAll('*').forEach((element) => {
    Array.from(element.attributes).forEach((attribute) => {
      const attrName = attribute.name.toLowerCase();
      const attrValue = attribute.value;

      if (attrName.startsWith('on') || attrName === 'style') {
        element.removeAttribute(attribute.name);
        return;
      }

      if (
        (attrName === 'href' || attrName === 'src' || attrName === 'xlink:href') &&
        JAVASCRIPT_PROTOCOL.test(attrValue)
      ) {
        element.removeAttribute(attribute.name);
      }
    });
  });

  return root.innerHTML;
};
